import * as Yup from "yup";
// define your fields
export const initialValues = {mobile: "", password: ""};

// define validation rules
export const validationSchema = Yup.object({
    mobile: Yup.string().required("یکی از موارد بالا را وارد نمایید"),
   // password: Yup.string().required("رمز عبور را وارد کنید").min(5, "رمز عبور باید حداقل شامل ۸ کاراکتر باشد")

    password: Yup.string()
})